module.exports = __webpack_public_path__ + "img/SPT.2787dcfd.jpg";